"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceMatrix = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _emailUtils = require("../../../../utils/emailUtils");
var _userflow = require("../../../../utils/userflow");
var _date = require("../../../../utils/date");
var _userflow2 = require("../../../../constants/userflow");
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _userflow3 = _interopRequireDefault(require("../../../../styles/userflow"));
var _PriceMatrixTitle = _interopRequireDefault(require("./PriceMatrixTitle"));
var _PriceMatrixCell = _interopRequireDefault(require("./PriceMatrixCell"));
var _Container = _interopRequireDefault(require("../Container"));
var _SurchargeAnnotation = _interopRequireDefault(require("../SurchargeAnnotation"));
var styles = {
  container: {
    fontSize: '14px',
    textAlign: 'center',
    tableLayout: 'fixed',
    overflow: 'hidden',
    display: 'block'
  },
  title: {
    fontSize: '22px',
    lineHeight: '25px',
    color: _userflow3["default"].colors.blackBase,
    mobile: {
      fontSize: '18px',
      lineHeight: '22px'
    }
  },
  matrix: {
    marginLeft: '-8px'
  }
};

/**
 * Проверяет, является ли текущий индекс скрываемым
 * выводим столбец с целевым кол-вом ночей ±2 на десктопе и ±1 на мобиле.
 * но т.к. у нас не может быть меньше 2х ночей, то целевое значение будет не в центре,
 * поэтому для 2х и 3х ночей мы скрываем 2 правых столбца
 * то же правило и для 30 ночей, в этом случае скрываем 2 правых
 * @param {number} index
 * @param {array} arr
 */
var indexToHide = function indexToHide(index, targetDuration) {
  if (targetDuration === 2 || targetDuration === 3) {
    return index > 2;
  }
  if (targetDuration === 29 || targetDuration === 30) {
    return index < 2;
  }
  return index === 0 || index === 4;
};
var getClassName = function getClassName(index, targetDuration) {
  return indexToHide(index, targetDuration) ? 'desktop-only-block' : '';
};
var getDurationRow = function getDurationRow(durations, targetDuration) {
  var durationsList = Object.keys(durations);
  return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null), durationsList.map(function (item, index) {
    var nightsCount = parseInt(item, 10);
    return /*#__PURE__*/_react["default"].createElement(_PriceMatrixTitle["default"], {
      key: item,
      title: item,
      description: (0, _userflow.pluralize)(nightsCount, _userflow2.NIGHT_WORD_FORMS),
      isTarget: nightsCount === targetDuration,
      className: getClassName(index, targetDuration)
    });
  }));
};
var Title = (0, _emailUtils.adaptiveStyled)('div', styles.title);
var PriceMatrix = exports.PriceMatrix = function PriceMatrix(_ref) {
  var targetDuration = _ref.targetDuration,
    priceMatrix = _ref.priceMatrix,
    surcharges = _ref.surcharges;
  var datesList = Object.entries(priceMatrix);
  var durationList = datesList[0][1];
  var datesMidIndex = Math.floor(datesList.length / 2);
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container,
    className: "price-matrix"
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 50
  }), /*#__PURE__*/_react["default"].createElement(Title, null, "\u0421\u0440\u0430\u0432\u043D\u0438\u0442\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043D\u043E\u0447\u0438 \u043E\u0442\u0434\u044B\u0445\u0430", /*#__PURE__*/_react["default"].createElement("br", null), "\u043D\u0430 \u0440\u0430\u0437\u043D\u044B\u0435 \u0434\u0430\u0442\u044B"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 11
  }), /*#__PURE__*/_react["default"].createElement("table", {
    cellSpacing: 0,
    cellPadding: 0,
    style: styles.matrix
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, getDurationRow(durationList, targetDuration), datesList.map(function (_ref2, dateIndex) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      date = _ref3[0],
      durations = _ref3[1];
    var durationsArr = Object.entries(durations);
    var day = (0, _date.formatDate)(date, 'dd');
    var month = (0, _date.formatDate)(date, 'MMM');
    var isTargetLine = dateIndex === datesMidIndex;
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: date
    }, /*#__PURE__*/_react["default"].createElement(_PriceMatrixTitle["default"], {
      title: day,
      description: month,
      isTarget: isTargetLine
    }), durationsArr.map(function (item, durationIndex) {
      var nightsCount = parseInt(item[0], 10);
      return /*#__PURE__*/_react["default"].createElement(_PriceMatrixCell["default"], {
        key: "".concat(date, "-").concat(item[0]),
        date: date,
        durations: item,
        isTargetOffer: isTargetLine && nightsCount === targetDuration,
        className: getClassName(durationIndex, targetDuration)
      });
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 10
  }), /*#__PURE__*/_react["default"].createElement(_SurchargeAnnotation["default"], null, surcharges === 'fully_known' ? 'Цены включают доплаты от туроператора' : 'Цены могут не включать доплаты от туроператора'));
};